var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import { Component } from 'vue-property-decorator';
import PriceSettingService from '../../api/PriceSettingService';
import _ from 'lodash';
import GLOBAL_VUE from '../../globalVue';
import { Loading } from 'element-ui';
import { toDetail } from '../../helper/util';
import { EBillType } from '../../enum/EBillType';
import { UrlHelper } from "../../helper/UrlWrapper";
import { mapGetters } from "vuex";
import CommonService from "../../api/CommonService";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tempSelectRows = [];
        _this.data = [];
        _this.total = 10;
        _this.headerSelectorType = [
            {
                id: 1,
                label: "客户名称"
            },
            {
                id: 2,
                label: "定价单号"
            },
            {
                id: 3,
                label: '货品名称'
            }
        ];
        return _this;
    }
    default_1.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time) || _.isDate(filter.e_time)) {
            filter.s_time = filter.s_time && filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time && filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.getList();
    };
    default_1.prototype.getList = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getOrderList(Object.assign(this.filter, this.$refs.pagination.pager)).then(function (res) {
            loadingInstance.close();
            _this.data = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.pageChange = function (pager) {
        this.getList();
    };
    default_1.prototype.selectionChange = function (rows) {
        this.tempSelectRows = rows;
    };
    default_1.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    default_1.prototype.confirm = function () {
        var _this = this;
        if (!this.tempSelectRows.length) {
            this.$message.error("请先选择单据!");
            return;
        }
        ;
        var ids = this.getSelectIds();
        this.$confirm("确认后将不可修改，是否继续？").then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.confirm(ids).then(function (result) {
                loadingInstance.close();
                if (result.data.code == 76) {
                    _this.$message.error(result.data.msg);
                }
                else {
                    _this.$message.success(result.data.msg || "确认成功");
                    _this.$refs.pagination.clear();
                }
                _this.getList();
                window._czc.push(["_trackEvent", '定价单确认', '定价单确认']);
            }, function (err) {
                loadingInstance.close();
                if (err.resData.flag == 1) {
                    _this.$confirm(err.resData.msg).then(function (result) {
                        _this.service.delete(err.resData.data.business_id).then(function (result) {
                            _this.$message.success(result.data.msg || "确认成功");
                            _this.$refs.pagination.clear();
                            _this.getList();
                        }).catch(function (err) {
                            _this.$message.error(err.message || err.msg);
                        });
                    });
                }
                else {
                    _this.$message.error(err.resData.msg);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }, function (err) { });
    };
    default_1.prototype.getSelectIds = function () {
        return this.tempSelectRows.map(function (item) { return item.order_id; }).join(",");
    };
    default_1.prototype.exportData = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = 'supplierclientapi/priceorder/export_priceorder?order_id=' + orderIds;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = _.cloneDeep(this.$refs.listHeader.formData);
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '定价单导出', '定价单导出']);
    };
    default_1.prototype.toDetail = function (row) {
        toDetail(EBillType.PriceSet, row.order_id, this);
    };
    default_1.prototype.created = function () {
        this.service = PriceSettingService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    default_1 = __decorate([
        Component({
            components: {
                'list-header': Header,
                'list-table': Table
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
